import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { intervalToDuration } from 'date-fns';
import styled from '@emotion/styled';

let interval: NodeJS.Timeout | null = null;
const Ticker = ({ fromTime }: { fromTime?: string }) => {
  if (!fromTime) {
    console.log('fromTime is required to display ticker');
    return null;
  }

  const now = +new Date();
  const fromTimeUtc = fromTime[fromTime.length - 1] !== 'Z' ? fromTime + 'Z' : fromTime;
  const start = +new Date(fromTimeUtc);

  const [ticker, setTicker] = useState(now - start);

  useEffect(() => {
    if (!fromTime) {
      interval && clearInterval(interval);
    } else {
      interval = setInterval(() => {
        setTicker(+new Date() - start);
      }, 1000);
    }
    return () => {
      interval && clearInterval(interval);
    };
  }, [fromTime]);

  const msToTime = (s: number) => {
    const i = intervalToDuration({ start: 0, end: s });
    if (i.months) {
      return `${i.months}mn ${i.days}d ${i.hours}h`;
    } else if (i.days) {
      return `${i.days}d ${i.hours}h ${i.minutes}m`;
    } else if (i.hours) {
      return `${i.hours}h ${i.minutes}m ${i.seconds}s`;
    } else if (i.minutes) {
      return `${i.minutes}m ${i.seconds}s`;
    } else {
      return `${i.seconds}s`;
    }
  };

  return (
    <TickerDiv>
      <Typography variant="subtitle2">{msToTime(ticker)}</Typography>
    </TickerDiv>
  );
};

export default Ticker;

const TickerDiv = styled.div`
  opacity: 0.8;
`;
